<style lang="scss">
@import "core";

.pg-top-links {

  & > li {
    margin-top: 8px;
  }

  @include mq(pc) {
    margin-left: -20px;

    & > li {
      display: inline-block;
      margin-left: 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "core";

.my {
  &__categories {
    margin-top: 30px;
  }

  &__category {
    &:not(:first-child) {
      margin-top: 30px;

      @include mq(sp) {
        margin-top: 20px;
      }
    }
  }

  &__option {
    margin-top: 30px;
  }

  &__total {
    margin-top: 20px;
    text-align: center;

    &__btn-calc {

      @include mq(sp) {
        width: 100%;
      }

      @include mq(pc) {
        min-width: 300px;
      }

      .dn-icon {
        margin-top: -.15em;
      }
    }

    &__separator {
      display: block;
      width: 200px;
      height: 50px;
      border-top: solid 50px #beebfa;
      border-left: solid 100px transparent;
      border-right: solid 100px transparent;

      @include mq(sp) {
        width: 100px;
        height: 25px;
        border-top: solid 25px #beebfa;
        border-left: solid 50px transparent;
        border-right: solid 50px transparent;
      }

      border-bottom: 0;
      margin: 20px auto;
    }

    &__loading {
      display: inline-block;
      vertical-align: middle;
    }

    &__result {
      border: solid 1px $color-divider;
      padding: 20px;
      text-align: center;

      &__values {
        display: inline-block;
      }

      &__value {
        color: $color-primary;
        margin: 0 .25em;

        @include mq(pc) {
          font-size: 24px;
        }

        @include mq(sp) {
          font-size: 16px;
        }
      }
    }

    &__area-retry {
      padding-top: 20px;
      text-align: center;
      transition: height .4s cubic-bezier(.4,0,.2,1);
    }

    &__btn-retry {

      @include mq(sp) {
        width: 220px;
      }

      @include mq(pc) {
        min-width: 220px;
      }
    }
  }

  &__btn-under  {
    @include mq(sp) {
      width: 100%;
    }

    @include mq(pc) {
      min-width: 360px;
    }

    @media all and (max-width: 400px) {
      font-size: 11px;
      padding-left: 0;
      padding-right: 0;
    }
  }

  &__btn-clear {
    margin-top: 30px;
    font-weight: bold;
  }

  &__btn-to-checker {
    margin-top: 20px;
  }
}
.manabi-jikosaiten {
  .my {
    &__categories {
      margin-top: 10px;
    }
  }
  .my-section__head-group {
    @include mq(pc) {
      margin-left: 156px;
    }
    .dn-heading-2 {
      text-align: left;
    }
  }
  .dn-tabs-top {
    margin-bottom: 25px;
    border-top: solid 1px $color-divider;
    a {
      @include mq(sp) {
        width: 100%;
      }
      margin-bottom: 25px;
    }
  }
  .dn-tabs {
    &__next {
      border-top: solid 1px $color-divider;
    }
  }
  .tar {
    .dn-btn {
      @include mq(sp) {
        width: 100%;
      }
    }
  }
}
</style>



<template>
  <div id="pg-app" :class="{'manabi-jikosaiten' : $store.getters['config/isManabi']}">
    <template v-if="$store.getters['config/isManabi']">
      <template v-if="$store.getters['config/checkerOpenFlg']['jikosaiten'] === '0'">
        <div class="dn-tabs__items">
          <div class="dn-tabs__content dn-tabs__content--active" style="border-top: 1px solid #adc4cc;">

            <p class="mb20">公開までしばらくお待ちください。<br>
            大学入学共通テストの解答を入力すると、自己採点結果を計算することができるツールです。</p>
          </div>
        </div>
      </template>
      <template v-else>
      <div class="dn-tabs__items"  v-if="$store.getters['config/isManabi']">
        <div class="dn-tabs__content dn-tabs__content--active dn-tabs-top">
          <p class="mb20">「自己採点結果の取得」を押して、「ベネッセ・駿台 データネット」で提出した自己採点結果を登録しましょう。</p>
          <div class="tar">
            <dn-btn 
              primary
              
              @click="getApiDataInit()">
              自己採点結果の取得
            </dn-btn>
          </div>
          <p>登録した内容で志望校の合格可能性判定を入力できます。<br>自己採点結果が取得できない場合は、手動で受験結果を入力し、登録してください。</p>
        </div>
      </div>


      <div class="pg-ready" v-if="isLoaded && !$store.getters['config/isManabi']">

        <div class="my__categories">
          <my-category
            class="my__category"
            v-for="category in categories"
            :key="category.id"
            :id="category.id"
            ref="categories"
          />
        </div>

        <my-option
          class="my__option"
          ref="option"
        />

        <div class="my__total">
          <dn-btn
            class="my__total__btn-calc"
            accent
            :disabled="!isActiveBtnCalculate"
            @click="onClickBtnCalculate"
          >
            <dn-icon
              icon="arrow-right"
              :class="{
                'is-white': isActiveBtnCalculate,
                'is-disabled': !isActiveBtnCalculate,
              }"
            />
            総合得点を計算する
          </dn-btn>

          <hr class="my__total__separator">

          <div class="my__total__result" ref="calculateResult">
            <div>
              あなたの総合得点は・・・・

              <dn-circle2
                v-if="isCalculating"
                class="my__total__loading"
                color="#0aa0d7"
                background="rgba(0, 0, 0, 0.25)"
              />

              <div class="my__total__result__values" v-if="isCalculated">
                <span class="my__total__result__value">{{totalHistory.score}}</span>点
                /<span class="my__total__result__max">{{totalHistory.max}}</span>点です。
              </div>
            </div>

            <dn-expand-transition>
              <div class="my__total__area-retry" v-show="isCalculated" ref="areaRetry">
                <dn-btn
                  class="my__total__btn-retry"
                  accent
                  @click="onClickBtnReset"
                >再集計する</dn-btn>
              </div>
            </dn-expand-transition>
          </div>

          <dn-btn plain class="my__btn-under my__btn-clear" @click="onClickBtnClear">計算結果を全てクリアしてやり直す</dn-btn>

          <dn-btn accent class="my__btn-under my__btn-to-checker" href="./hantei/index.html" v-linkset="'C36'">合格可能性判定{{$store.getters['config/isManabi'] ? '' : '　判定チェッカー'}}</dn-btn>
        </div>
      </div>

      
      <div class="dn-tabs__bar" v-if="$store.getters['config/isManabi']">
        <div class="dn-tabs__container">
          <a href="../bible/mock/index.html" class="dn-tabs__item">
            進研模試 3年10月
          </a>
          <a href="./index.html" class="dn-tabs__item dn-tabs__item--active">
            自己採点
          </a>
        </div>
      </div>
      <div class="dn-tabs__items">
        <div class="dn-tabs__content dn-tabs__content--active">
  <!--
          <div class="dn-tabs mt20">
            <div class="dn-tabs__bar">
              <div class="dn-tabs__container">
                <a class="dn-tabs__item dn-center-tabs__item--active" href="./../../center/jikosaiten/index.html">第１日程</a>
                <a class="dn-tabs__item" href="./../../center2/jikosaiten/index.html">第２日程</a>
              </div>
              <div class="dn-center-tabs__item--under"></div>
              
            </div>
          </div> -->
          <div class="pg-ready" v-if="isLoaded">
            <div class="my__categories">
              <my-category
                class="my__category"
                v-for="category in categories"
                :key="category.id"
                :id="category.id"
                ref="categories"
              />
            </div>

            <my-option
              class="my__option"
              ref="option"
            />
            <div class="my__total">
              <dn-btn
                class="my__total__btn-calc"
                accent
                :disabled="!isActiveBtnCalculate"
                @click="onClickBtnCalculate"
              >
                <dn-icon
                  icon="arrow-right"
                  :class="{
                    'is-white': isActiveBtnCalculate,
                    'is-disabled': !isActiveBtnCalculate,
                  }"
                />
                総合得点を計算する
              </dn-btn>

              <hr class="my__total__separator">

              <div class="my__total__result" ref="calculateResult">
                <div>
                  あなたの総合得点は・・・・

                  <dn-circle2
                    v-if="isCalculating"
                    class="my__total__loading"
                    color="#0aa0d7"
                    background="rgba(0, 0, 0, 0.25)"
                  />

                  <div class="my__total__result__values" v-if="isCalculated">
                    <span class="my__total__result__value">{{totalHistory.score}}</span>点
                    /<span class="my__total__result__max">{{totalHistory.max}}</span>点です。
                  </div>
                </div>

                <dn-expand-transition>
                  <div class="my__total__area-retry" v-show="isCalculated" ref="areaRetry">
                    <dn-btn
                      class="my__total__btn-retry"
                      accent
                      @click="onClickBtnReset"
                    >再集計する</dn-btn>
                  </div>
                </dn-expand-transition>
              </div>

              <dn-btn plain class="my__btn-under my__btn-clear" @click="onClickBtnClear">計算結果を全てクリアしてやり直す</dn-btn>
            </div>
            <!--
            <div class="my__total">
              <div class="my-section__head-group">
                <h2 class="dn-heading-2">Step2:志望校を登録する</h2>
              </div>
              <dn-btn accent class="my__btn-under my__btn-to-checker" href="../bible/search/index.html" v-linkset="'C36'">志望校の登録{{$store.getters['config/isManabi'] ? '' : '　判定チェッカー'}}</dn-btn>
            </div>
            -->
          </div>
          <dn-dialog ref="dialog-alert_success">
            <div slot="header"></div>
            <div class="my-body">取得に成功しました。<br>
            </div>
            <div slot="footer">
              <dn-btn block-sp @click="screenReload()">OK</dn-btn>
            </div>
          </dn-dialog>    
          <dn-dialog ref="dialog-alert_noscore">
            <div slot="header"></div>
            <div class="my-body">成績がありませんでした。</div>
            <div slot="footer">
              <dn-btn block-sp @click="screenReload()">OK</dn-btn>
            </div>
          </dn-dialog>
          <dn-dialog ref="dialog-alert_scoreerr">
            <div slot="header"></div>
            <div class="my-body">通信に失敗しました。</div>
            <div slot="footer">
              <dn-btn block-sp @click="screenReload()">OK</dn-btn>
            </div>
          </dn-dialog>
        </div>
      </div>
      <div class="dn-tabs__items" style="text-align:center;">
        <dn-icon icon="tri-down--lg" />
        <div class="dn-tabs__content dn-tabs__content--active dn-tabs__next">
          <p class="mb10" style="font-size:16px;">次に、志望校を登録しましょう</p>
          <dn-btn accent class="my__btn-under my__btn-to-checker" @click="onClickBtnChecker('../bible/search/index.html')" v-linkset="'C36'" style="font-size:14px;">STEP2 志望校の登録へ　＞＞</dn-btn>
        </div>
      </div>
      </template>
    </template>
    <template v-else>
    <div class="tar">
      <dn-btn
        primary
        v-if="$store.getters['config/isManabi']"
        @click="getApiData()">
        自己採点結果の取得
        </dn-btn>
    </div>
<!-- 
    <div class="dn-tabs mt20">
      <div class="dn-tabs__bar">
        <div class="dn-tabs__container">

            <a class="dn-tabs__item dn-center-tabs__item--active" v-linkset="'D1'" href="./../../center/jikosaiten/index.html">第１日程</a>
            <a class="dn-tabs__item" v-linkset="'D2'" href="./../../center2/jikosaiten/index.html">第２日程</a>
        </div>
        <div class="dn-center-tabs__item--under"></div>
        
      </div>
    </div> -->


    <div class="pg-ready" v-if="isLoaded">

      <div class="my__categories">
        <my-category
          class="my__category"
          v-for="category in categories"
          :key="category.id"
          :id="category.id"
          ref="categories"
        />
      </div>

      <my-option
        class="my__option"
        ref="option"
      />

      <div class="my__total">
        <dn-btn
          class="my__total__btn-calc"
          accent
          :disabled="!isActiveBtnCalculate"
          @click="onClickBtnCalculate"
        >
          <dn-icon
            icon="arrow-right"
            :class="{
              'is-white': isActiveBtnCalculate,
              'is-disabled': !isActiveBtnCalculate,
            }"
          />
          総合得点を計算する
        </dn-btn>

        <hr class="my__total__separator">

        <div class="my__total__result" ref="calculateResult">
          <div>
            あなたの総合得点は・・・・

            <dn-circle2
              v-if="isCalculating"
              class="my__total__loading"
              color="#0aa0d7"
              background="rgba(0, 0, 0, 0.25)"
            />

            <div class="my__total__result__values" v-if="isCalculated">
              <span class="my__total__result__value">{{totalHistory.score}}</span>点
              /<span class="my__total__result__max">{{totalHistory.max}}</span>点です。
            </div>
          </div>

          <dn-expand-transition>
            <div class="my__total__area-retry" v-show="isCalculated" ref="areaRetry">
              <dn-btn
                class="my__total__btn-retry"
                accent
                @click="onClickBtnReset"
              >再集計する</dn-btn>
            </div>
          </dn-expand-transition>
        </div>

        <dn-btn plain class="my__btn-under my__btn-clear" @click="onClickBtnClear">計算結果を全てクリアしてやり直す</dn-btn>

        <dn-btn accent class="my__btn-under my__btn-to-checker" @click="onClickBtnChecker('./hantei/index.html')" v-linkset="'C36'">合格可能性判定{{$store.getters['config/isManabi'] ? '' : '　判定チェッカー'}}</dn-btn>
      </div>
    </div>
    <dn-dialog ref="dialog-alert_noscore">
      <div slot="header"></div>
      <div class="my-body">成績がありませんでした。</div>
      <div slot="footer">
        <dn-btn block-sp @click.native.stop="$refs['dialog-alert_noscore'].hide" style="margin-left:7em">OK</dn-btn>
      </div>
    </dn-dialog>
    <dn-dialog ref="dialog-alert_scoreerr">
      <div slot="header"></div>
      <div class="my-body">通信に失敗しました。</div>
      <div slot="footer">
        <dn-btn block-sp @click.native.stop="$refs['dialog-alert_scoreerr'].hide" style="margin-left:7em">OK</dn-btn>
      </div>
    </dn-dialog>
    </template>
  </div>
</template>



<script>
import MyCategory from './components/Category';
import MyOption from './components/Option';
import JudgementInfo from 'models/judgementInfo';
import 'whatwg-fetch';



const DEFAULT_CONFIG = {
  apiPost: true,
  apiUrl : 'https://dn.benesse.ne.jp/resultRegistarAPI/',
  debug  : false,
};



export default {
  name: 'dn-selfcheck-index-app',

  components: {
    MyCategory,
    MyOption,
  },

  provide() {
    return {
      resetCaliculateState: this.resetCaliculateState,
    }
  },

  data() {
    return {
      mounted: false,
      loadState: 'pending',
      config: null,
      calculateState: 'pending',
    }
  },

  computed: {
    year() { return this.$store.getters['config/year'] },
    seisekiApiConfig() { return this.$store.getters['config/seisekiApi'] },
    isLoading() { return this.loadState === 'loading' },
    isLoaded() { return this.loadState === 'loaded' },
    mountAndLoaded() { return this.mounted && this.isLoaded },

    isDebug() { return this.config.debug },
    apiPost() { return this.config.apiPost },
    apiUrl() { return this.$store.getters['config/envIs']('develop') ? '/resultRegistarAPI/' : this.config.apiUrl },

    categories() { return this.isLoaded && this.$store.getters['selfcheck/groupedCategories'] },
    fixedSubjects() { return this.isLoaded ? this.$store.getters['selfcheck/fixedSubjects'] : [] },
    indeterminateSubjects() { return this.isLoaded ? this.$store.getters['selfcheck/indeterminateSubjects'] : [] },
    totalHistory() { return this.isLoaded && this.$store.getters['selfcheck/totalHistory'] },
    canCalculate() { return this.fixedSubjects.length > 0 && this.indeterminateSubjects.length === 0 },
    isActiveBtnCalculate() { return this.canCalculate && !this.isCalculating && !this.isCalculated },
    isCalculating() { return this.calculateState === 'calculating' },
    isCalculated() { return this.calculateState === 'calculated' },
    isManabi() { return this.$store.getters['config/isManabi'] },
    data() { return this.$store.getters['selfcheck/groupedCategoryById'](this.id) },
    subjects() { return this.data.subjects },
    firstChoiceSubjects() {
      return this.subjects.map(subject => {
        const history = this.$store.getters['selfcheck/subjectHistory'](subject.id);
        return {
          id   : subject.id,
          name : subject.name,
          fixed: history.state === 'fixed',
        }
      });
    },
    firstChoice() { return this.$store.getters['selfcheck/groupedCategoryFirstChoice'](this.id) },
  },

  watch: {
    mountAndLoaded(val) {
      if (val) this.tryScrollToSubjectAnchor();
    },
  },

  methods: {
    async init() {
      this.loadState = 'loading';
      await Promise.all([
        this.$store.dispatch('selfcheck/load'),
        this.loadConfig(),
      ]);
      await this.setupSelectionMode();

      dn.window.on('show.dn-selfcheck-app', () => {
        this.setupSelectionMode();
      });

      this.loadState = 'loaded';
    },

    async setupSelectionMode() {
      const selectionMode = this.$store.getters['config/isManabi'] ? 'direct' : 'selfcheck';
      const subjects = this.$store.getters['selfcheck/subjects'];
      const selectionChangePromises = [];
      for (let subject of subjects) {
        const history = this.$store.getters['selfcheck/subjectHistory'](subject.id);
        if (selectionMode === 'direct') {
          selectionChangePromises.push(this.$store.dispatch('selfcheck/setSubjectHistory', {id: subject.id, data: {type: 'direct'}}));
        } else if (selectionMode === 'selfcheck') {
          if (history.type !== 'selfcheck' && history.selfcheckScore === null && history.directScore === null) {
            selectionChangePromises.push(this.$store.dispatch('selfcheck/setSubjectHistory', {id: subject.id, data: {type: 'selfcheck'}}));
          }
        }
      }
      if (selectionChangePromises.length) {
        await Promise.all(selectionChangePromises);
      }
    },

    async loadConfig() {
      const url = this.$store.getters['path/$join']('resources', 'jikosaiten/js/variable.json');
      const res = await this.$http.get(url);

      this.config = Object.assign({}, DEFAULT_CONFIG, res.data);

      if (this.isDebug || this.$store.getters['config/envIs']('develop')) {
        console.group('自己採点API送信設定');
        console.log(JSON.parse(JSON.stringify(this.config)));
        console.groupEnd();
      }
    },

    async onClickBtnCalculate() {
      const optionErrors = this.$refs.option.errors;
      if (optionErrors.length) {
        dn.$alert(optionErrors.join('\n'));
        return false;
      }

      if (this.isDebug) {
        if (!await dn.$confirm(
            '計算処理を実行します。\n\n' +
            '送信先URL: ' + this.apiUrl + '\n' +
            '送信フラグ: ' + (this.apiPost ? '送信する' : '送信しない') + '\n' +
            'ID: ' + this.$store.getters['segments/device/uid'] + '\n' +
            'デバイス : ' + (this.$store.getters['segments/device/type'] === 1 ? 'PC' : 'スマートフォン')
        )) {
          dn.$alert('キャンセルしました。');
          return false;
        }
      }
      return this.calculateTotalScore();
    },

    getInputById(id) {
      const $ref = this.$refs[`subjectScoreFields-${id}`];
      return $ref ? $ref[0] : null;
    },

    getSendApiParams() {
      return Object.assign(
        this.getSendOptions(),
        {p9: this.totalHistory.score},
        this.getSendSubjectData(),
      );
    },

    getSendOptions() {
      const selectedOptions = this.$refs.option.targetValues;
      return {
        p1: this.year,
        p2: this.$store.getters['segments/device/uid'],
        p5: this.$store.getters['segments/device/type'],
        p6: selectedOptions.liberal,
        p7: selectedOptions.pref,
        p8: selectedOptions.questionnaire,
      }
    },

    // @see: store.getters.selfcheck/subjectInputsApiParams
    getSendSubjectData() {
      const data = {};
      const fixedSubjects = this.$store.getters['selfcheck/fixedSubjects'];
      for (let subject of fixedSubjects) {
        Object.assign(data, this.$store.getters['selfcheck/subjectInputsApiParams'](subject.id));
      }
      return data;
    },

    async sendApiParams(params) {
      if (!this.apiPost) return;

      const url = this.apiUrl;

      try {
        const res = await this.$http.post(url, {data: params});
        if (!res.data || res.data !== '<html><head></head><body>OK</body></html>') {
          console.warn('自己採点APIからのフォーマットが異常ですが、エラー処理をキャンセルします');
          console.warn(res);
        }
      } catch(e) {
        console.warn('自己採点APIへの送信でエラーが発生しましたが、エラー処理をキャンセルします');
        console.warn(e);
      }
    },

    async calculateTotalScore() {
      this.calculateState = 'calculating';
      this.$scrollTo(this.$refs.calculateResult);
      const params = this.getSendApiParams();
      await this.sendApiParams(params);
      this.calculateState = 'calculated';
    },

    async onClickBtnClear() {
      if (await dn.$confirm('入力した内容が全て消えますがよろしいですか？')) {
        this.allClear();
      }
      if (this.$store.getters['config/isManabi']) {
        // リセットしてリロード（マナビ採点表示暫定対応）
        this.screenReload();
      }
    },

    // 画面遷移時、第1解答科目を選択しているかチェック
    async onClickBtnChecker(url) {
      var info = new JudgementInfo();
      await info.init()
      await info.updateHistories();
      if (info.firstChoiceErrors.slice().length > 0) {
        var firstChoiceErrors = info.firstChoiceErrors.map(error => error.name);
        if (!confirm(firstChoiceErrors.join("、") + "の第1解答科目が未選択ですがよろしいですか？")) {
          return;
        }
      }
      location.href = url;
    },

    onClickBtnReset() {
      return this.reset();
    },

    resetCaliculateState() {
      this.calculateState = 'pending';
    },

    reset() {
      this.resetCaliculateState();
      this.$nextTick(() => {
        this.$scrollTo(document.body);
      });
    },

    async allClear() {
      this.$store.dispatch('selfcheck/clearAllHistories');
      this.reset();
    },

    tryScrollToSubjectAnchor() {
      if (!location.hash) return;

      const id = location.hash.replace(/^#/, '');
      if (!/^\d{3}$/.test(id)) return;

      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.getElementById(`a${id}`);
          window.scrollTo(0, el.offsetTop);
          window.history && history.replaceState && history.replaceState('', document.title, window.location.pathname + window.location.search);
        }, 100);
      });
    },

    // 成績取得初期設定
    getApiDataInit() {
      // 成績取得前にデータをクリアする
      // this.clearDirectScore();
      this.$store.dispatch('selfcheck/clearAllHistories');
      // 通信
      this.getApiData();
    },

    getApiData() {
              // 2021年DN回の成績を取得
              window.fetch(/*"../data/examRslt.json"*/
                    this.seisekiApiConfig.domain.manabi + "seiseki/services/dnExamRslt",
                    // "/manabi/center/resources/data/dnExamRslt.json",
                    {
                      credentials: "include",
                      headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                      },
                      referrer: this.seisekiApiConfig.domain.dn,
                      referrerPolicy: "no-referrer-when-downgrade",
                      // 2021年DN回
                      body: "{\"examId\":\"" + this.seisekiApiConfig.examId.dn.replace("{GAKUNEN}", "K3") + "\"}",
                      method: "POST",
                      mode: "cors"
                    }
                    ).then(exm_response => {
                      return exm_response.json();

                    }).then(octoberScore => {

                      if (!octoberScore.seiseki) {
                        // 通信エラー
                        (this.$refs[`dialog-alert_noscore`]).show();
                        return;
                      } else if(!octoberScore.seiseki.seisekiList) {
                        // 成績が無い場合
                        // (this.$refs[`dialog-alert_noscore`]).show();
                        // 高校3年生で成績が取れない場合、既卒で取りに行く
                        this.getApiDataKisotu();
                        return;
                      } else {
                        // 成績がある場合
                        (this.$refs[`dialog-alert_success`]).show();
                      }

                      let subjectScore = $.grep(octoberScore.seiseki.seisekiList,
                        function(score) {
                          return score.kmkType === 2;
                        });

                      if (subjectScore.length < 1) {
                        (this.$refs[`dialog-alert_noscore`]).show();
                        return;
                      }
                      this.$refs.categories.forEach(category => {
                        category.$refs.subjects.forEach(subject => {
                          let id = subject.$el.id.replace('subject-', '');
                          let target = $.grep(subjectScore, function(score) {
                            return score.kmkCrsCd.slice(-3) === id;
                          });
                          if (target.length > 0) {
                            let data = {
                              type: "direct",
                              directScore: target[0].keiten,
                              selected: true,
                              selfCheckIsFinished: false
                            };
                            this.$store.dispatch('selfcheck/setSubjectHistory', { id, data });
                          }
                          // 現代文・古文・漢文表示対応
                          if (id === "106") {
                            subject.$children.forEach(sub_subject => {
                              let id = sub_subject.$el.id.replace('subject-', '');
                              let target = $.grep(subjectScore, function(score) {
                                return score.kmkCrsCd.slice(-3) === id;
                              });
                              if (target.length > 0) {
                                let data = {
                                  type: "direct",
                                  directScore: target[0].keiten,
                                  selected: true,
                                  selfCheckIsFinished: false
                                };
                                this.$store.dispatch('selfcheck/setSubjectHistory', { id, data });
                              }
                            })
                          }
                        });
                      });
                      this.setFirstChoiceFlg(subjectScore);
                    }).catch(exm_err => {
                      (this.$refs[`dialog-alert_scoreerr`]).show();
                    });
    },
    /** 第一解答科目を設定する */
    setFirstChoiceFlg(subjectScore) {
      const NEED_FIRST_CHOICE_MAP = {
        soci: {groupId: '1_2'}, // 地理歴史・公民
        scie: {groupId: '6'  , uses: ['513', '523', '533', '543']}, // 理科
      };
      var firstchoiceSociFlg = false;
      var firstchoiceScieFlg = false;
      // 地理歴史・公民か理科のみを対象
      let target = $.grep(subjectScore, function(score) {
          return score.kmkCrsCd.slice(1,2) === '4' || score.kmkCrsCd.slice(1,2) === '5';
      });
      if (target.length > 0) {
        target.forEach(score => {
          let id = score.kmkCrsCd.slice(-3);
          if (id.slice(0,1) === '4') {
            // 先頭の科目コードを第一解答科目として設定する。
            if (!firstchoiceSociFlg) {
              this.$store.dispatch('selfcheck/setGroupedCategoryFirstChoice', {categoryId: NEED_FIRST_CHOICE_MAP["soci"].groupId, subjectId: id});
              firstchoiceSociFlg = true;
            }
          }
          if (id.slice(0,1) === '5' && (NEED_FIRST_CHOICE_MAP["scie"].uses).includes(id)) {
            // 先頭の科目コードを第一解答科目として設定する。
            if (!firstchoiceScieFlg) {
              this.$store.dispatch('selfcheck/setGroupedCategoryFirstChoice', {categoryId: NEED_FIRST_CHOICE_MAP["scie"].groupId, subjectId: id});
              firstchoiceScieFlg = true;
            }
          }
        })
      }
    },
    // 成績取得（既卒）
    getApiDataKisotu() {
              // 2021年DN回の成績を取得
              window.fetch(/*"../data/examRslt.json"*/
                    this.seisekiApiConfig.domain.manabi + "seiseki/services/dnExamRslt",
                    // '/manabi/center/resources/data/dnExamRslt.json',
                    {
                      credentials: "include",
                      headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                      },
                      referrer: this.seisekiApiConfig.domain.dn,
                      referrerPolicy: "no-referrer-when-downgrade",
                      // 2021年DN回
                      body: "{\"examId\":\"" + this.seisekiApiConfig.examId.dn.replace("{GAKUNEN}", "S4") + "\"}",
                      method: "POST",
                      mode: "cors"
                    }
                    ).then(exm_response => {
                      return exm_response.json();

                    }).then(octoberScore => {

                      if (!octoberScore.seiseki) {
                        // 通信エラー
                        (this.$refs[`dialog-alert_noscore`]).show();
                        return;
                      } else if(!octoberScore.seiseki.seisekiList) {
                        // 成績が無い場合
                        (this.$refs[`dialog-alert_noscore`]).show();
                        return;
                      } else {
                        // 成績がある場合
                        (this.$refs[`dialog-alert_success`]).show();
                      }

                      let subjectScore = $.grep(octoberScore.seiseki.seisekiList,
                        function(score) {
                          return score.kmkType === 2;
                        });

                      if (subjectScore.length < 1) {
                        (this.$refs[`dialog-alert_noscore`]).show();
                        return;
                      }

                      this.$refs.categories.forEach(category => {
                        category.$refs.subjects.forEach(subject => {
                          let id = subject.$el.id.replace('subject-', '');

                          let target = $.grep(subjectScore, function(score) {
                            return score.kmkCrsCd.slice(-3) === id;
                          });

                          if (target.length > 0) {
                            let data = {
                              type: "direct",
                              directScore: target[0].keiten,
                              selected: true,
                              selfCheckIsFinished: false
                            };

                            this.$store.dispatch('selfcheck/setSubjectHistory', { id, data });
                          }
                          // 現代文・古文・漢文表示対応
                          if (id === "106") {
                            subject.$children.forEach(sub_subject => {
                              let id = sub_subject.$el.id.replace('subject-', '');
                              let target = $.grep(subjectScore, function(score) {
                                return score.kmkCrsCd.slice(-3) === id;
                              });
                              if (target.length > 0) {
                                let data = {
                                  type: "direct",
                                  directScore: target[0].keiten,
                                  selected: true,
                                  selfCheckIsFinished: false
                                };
                                this.$store.dispatch('selfcheck/setSubjectHistory', { id, data });
                              }
                            })
                          }
                        });
                      });

                    }).catch(exm_err => {
                      (this.$refs[`dialog-alert_scoreerr`]).show();
                    });
    },

    // 画面リロード
    screenReload () {
      location.reload();
    }

  },


  mounted() {
    this.mounted = true;
  },

  created() {
    this.init();
  },
}
</script>



// WEBPACK FOOTER //
// App.vue?1eb05554